<template>
  <div class="content-wrapper">
    <div v-if="month === '202006'">
      <KeyVisual06 :month="month"/>
    </div>
    <div v-if="month === '202007'">
      <KeyVisual07 :month="month"/>
    </div>
    <div v-if="month === '202008'">
      <KeyVisual08 :month="month"/>
    </div>
    <div v-if="month === '202010'">
      <KeyVisual10tsuruha :month="month"/>
    </div>
    <!-- <div v-if="month === '202010'">
      <FestaDivision09sendai :month="month" :isReal="isReal" @change-participate-type="changeParticipateType" />
    </div> -->
    <div v-if="month === '202009'">
      <KeyVisual09sendai :month="month"/>
    </div>
    <div v-if="month === '202009'">
      <FestaDivision09sendai :month="month" :isReal="isReal" @change-participate-type="changeParticipateType" />
    </div>
    <div v-if="month === '202006'">
      <Channel06 :month="month"/>
    </div>
    <div v-if="month === '202007'">
      <Channel07 :month="month"/>
    </div>
    <div v-if="month === '202008'">
      <Channel08 :month="month"/>
    </div>
    <div v-if="month === '202006'">
      <Live06 :month="month"/>
    </div>
    <div v-if="month === '202007'">
      <Live07 :month="month"/>
    </div>
    <div v-if="month === '202008'">
      <Live08 :month="month"/>
    </div>
    <div v-if="month === '202009'">
      <Live09sendai :month="month" :contentType="contentType" :isReal="isReal" />
    </div>
    <div v-if="month === '202010'">
      <Live10tsuruha :month="month" :contentType="contentType"/>
    </div>
    <div v-if="month === '202006'">
      <Present06 :month="month"/>
    </div>
    <div v-if="month === '202007'">
      <Present07 :month="month"/>
    </div>
    <div v-if="month === '202008'">
      <Present08 :month="month"/>
    </div>
    <div v-if="month === '202009'">
      <Present09sendai :month="month"/>
    </div>
    <div v-if="month === '202010'">
      <Present10tsuruha :month="month"/>
    </div>
    <div v-if="month === '202010'">
      <Banner10tsuruha :month="month"/>
    </div>
    <div v-if="month === '202009'">
      <Summary09sendai :month="month"/>
    </div>
    <div v-if="month === '202009'">
      <Sponsor09sendai :month="month"/>
    </div>
    <div v-if="month === '202010'">
      <Footer10tsuruha :month="month"/>
    </div>
    <Floating>
      <template #content>
        <div v-if="month === '202006'">
          <Button06 :loaded="loaded" :isAuthed="isAuthed" :month="month" @to-login="$emit('to-login')"/>
        </div>
        <div v-if="month === '202007'">
          <Button07 :loaded="loaded" :isAuthed="isAuthed" :month="month" @to-login="$emit('to-login')"/>
        </div>
        <div v-if="month === '202008'">
          <Button08 :loaded="loaded" :isAuthed="isAuthed" :month="month" @to-login="$emit('to-login')"/>
        </div>
        <div v-if="month === '202010'">
          <Button10tsuruha :loaded="loaded" :isAuthed="isAuthed" :month="month"/>
        </div>
        <div v-if="month === '202009'">
          <Button09sendai :loaded="loaded" :isAuthed="isAuthed" :month="month" @to-login="$emit('to-login')"/>
        </div>
      </template>
    </Floating>
  </div>
</template>

<script>
import KeyVisual06 from '@/components/organisms/202006/contents/KeyVisual.vue'
import KeyVisual07 from '@/components/organisms/202007/contents/KeyVisual.vue'
import KeyVisual08 from '@/components/organisms/202008/contents/KeyVisual.vue'
import KeyVisual10tsuruha from '@/components/organisms/202010tsuruha/contents/KeyVisual.vue'
import KeyVisual09sendai from '@/components/organisms/202009sendai/contents/KeyVisual.vue'
import FestaDivision09sendai from '@/components/organisms/202009sendai/contents/FestaDivision.vue'
import Channel06 from '@/components/organisms/202006/contents/Channel.vue'
import Channel07 from '@/components/organisms/202007/contents/Channel.vue'
import Channel08 from '@/components/organisms/202008/contents/Channel.vue'
import Live06 from '@/components/organisms/202006/contents/Live.vue'
import Live07 from '@/components/organisms/202007/contents/Live.vue'
import Live08 from '@/components/organisms/202008/contents/Live.vue'
import Live09sendai from '@/components/organisms/202009sendai/contents/Live.vue'
import Live10tsuruha from '@/components/organisms/202010tsuruha/contents/Live.vue'
import Present06 from '@/components/organisms/202006/contents/Present.vue'
import Present07 from '@/components/organisms/202007/contents/Present.vue'
import Present08 from '@/components/organisms/202008/contents/Present.vue'
import Present09sendai from '@/components/organisms/202009sendai/contents/Present.vue'
import Present10tsuruha from '@/components/organisms/202010tsuruha/contents/Present.vue'
import Summary09sendai from '@/components/organisms/202009sendai/contents/Summary.vue'
import Sponsor09sendai from '@/components/organisms/202009sendai/contents/Sponsor.vue'
import Footer10tsuruha from '@/components/organisms/202010tsuruha/contents/Footer.vue'
import Banner10tsuruha from '@/components/organisms/202010tsuruha/contents/Banner.vue'
import Floating from '@/components/molecules/Floating.vue'
import Button06 from '@/components/atoms/202006/Button.vue'
import Button07 from '@/components/atoms/202007/Button.vue'
import Button08 from '@/components/atoms/202008/Button.vue'
import Button10tsuruha from '@/components/atoms/202010tsuruha/Button.vue'
import Button09sendai from '@/components/atoms/202009sendai/Button.vue'

export default {
  data: () => ({
    contentType: '',
    isReal: true
  }),
  props: {
    loaded: {
      type: Boolean,
      required: true
    },
    isAuthed: {
      type: Boolean,
      required: true
    },
    month: {
      type: String,
      required: true
    }
  },
  methods: {
    changeParticipateType (real) {
      if (real === 'real') {
        this.isReal = true
      } else {
        this.isReal = false
      }
    }
  },
  components: {
    KeyVisual06,
    KeyVisual07,
    KeyVisual08,
    KeyVisual10tsuruha,
    KeyVisual09sendai,
    FestaDivision09sendai,
    Channel06,
    Channel07,
    Channel08,
    Live06,
    Live07,
    Live08,
    Live09sendai,
    Live10tsuruha,
    Present06,
    Present07,
    Present08,
    Present09sendai,
    Present10tsuruha,
    Sponsor09sendai,
    Summary09sendai,
    Footer10tsuruha,
    Banner10tsuruha,
    Floating,
    Button06,
    Button07,
    Button08,
    Button09sendai,
    Button10tsuruha
  }
}
</script>

<style lang="sass" scoped>
.container.schedule
  font-size: 24px
</style>
